import accessTokenStorage from 'containers/services/security/access-token-storage';
import { callApi } from 'helpers/saga-helpers';
import { get } from 'lodash';
import { put, select, takeLeading } from 'redux-saga/effects';
import {
  REQUEST_UPDATE_CLAIM_NUMBER,
  REQUEST_CREATE_MISSION,
  REQUEST_GET_PROVISIONAL_CLAIM_DETAILS,
  REQUEST_VALIDATE_PROVISIONAL_LIAISON,
  REQUEST_REJECT_PROVISIONAL_LIAISON,
} from 'containers/ProvisionalClaimRecap/constants';
import {
  requestGetProvisionalClaimDetails,
  setProvisionalClaimDetails,
  setUpdateClaimNumberResult,
} from 'containers/ProvisionalClaimRecap/actions';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import { LOADERS } from 'containers/AppContainer/Loader/constants';
import { makeSelectUpdateClaimNumberResult } from 'containers/ProvisionalClaimRecap/selectors';

export function* requestProvisionalDetails(action: any): Generator {
  const { provisionalClaimId, isIntervenant } = action;
  const token = isIntervenant
    ? yield select(makeSelectKeycloakToken())
    : accessTokenStorage.get().token;
  if (!token) return;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };
  const path = isIntervenant
    ? `/corporeal/provisional-claim/${provisionalClaimId}?isIntervenant=true`
    : `/corporeal/provisional-claim/${provisionalClaimId}`;
  yield callApi(
    path,
    {},
    options,
    [],
    setProvisionalClaimDetails,
    undefined,
    false,
    LOADERS.PROVISIONAL_CLAIM_DETAILS,
  );
}

export function* requestProvisionalDetailsSaga() {
  yield takeLeading(
    REQUEST_GET_PROVISIONAL_CLAIM_DETAILS,
    requestProvisionalDetails,
  );
}

export function* requestCreateMission(action: any): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = accessTokenStorage.get().token;
  if (!token) return;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };
  const path = `/corporeal/mission/provisional`;
  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield put(
      requestGetProvisionalClaimDetails(
        get(payload, 'provisionalClaimId'),
        false,
      ),
    );
    yield successCallback();
  }
}

export function* requestCreateMissionSaga() {
  yield takeLeading(REQUEST_CREATE_MISSION, requestCreateMission);
}

export function* requestUpdateClaimNumber(action: any): Generator<unknown> {
  const { provisionalClaimId, claimNumber, failedCallBack } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (!token) return;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      claimNumber,
    }),
  };
  const path = `/corporeal/provisional-claim/update-claim-number/${provisionalClaimId}`;
  yield callApi(path, {}, options, [], setUpdateClaimNumberResult);
  const updateResult = yield select(makeSelectUpdateClaimNumberResult());
  const isClaimNumberExist = get(updateResult, 'isClaimNumberExist', false);
  const isProvisionalClaimUpdated = get(
    updateResult,
    'isProvisionalClaimUpdated',
    false,
  );
  if (isProvisionalClaimUpdated && isClaimNumberExist) {
    yield put(requestGetProvisionalClaimDetails(provisionalClaimId, true));
  } else yield failedCallBack();
}

export function* requestUpdateClaimNumberSaga() {
  yield takeLeading(REQUEST_UPDATE_CLAIM_NUMBER, requestUpdateClaimNumber);
}

export function* requestValidateProvisionalLiaison(
  action: any,
): Generator<unknown> {
  const { provisionalClaimId, successCallBack } = action;
  const token = accessTokenStorage.get().token;
  if (!token) return;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      provisionalClaimId,
    }),
  };
  const path = `/corporeal/common/migrate-provisional-claim-to-claim`;
  const errorResponse = yield callApi(path, {}, options, []);
  if (!errorResponse) {
    yield put(requestGetProvisionalClaimDetails(provisionalClaimId, false));
    yield successCallBack();
  }
}

export function* requestValidateProvisionalLiaisonSaga() {
  yield takeLeading(
    REQUEST_VALIDATE_PROVISIONAL_LIAISON,
    requestValidateProvisionalLiaison,
  );
}

export function* requestRejectProvisionalLiaison(
  action: any,
): Generator<unknown> {
  const { provisionalClaimId, successCallBack } = action;
  const token = accessTokenStorage.get().token;
  if (!token) return;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      provisionalClaimId,
    }),
  };
  const path = `/corporeal/provisional-claim/reject-provisional-liaison`;
  const errorResponse = yield callApi(path, {}, options, []);
  if (!errorResponse) {
    yield put(requestGetProvisionalClaimDetails(provisionalClaimId, false));
    yield successCallBack();
  }
}

export function* requestRejectProvisionalLiaisonSaga() {
  yield takeLeading(
    REQUEST_REJECT_PROVISIONAL_LIAISON,
    requestRejectProvisionalLiaison,
  );
}

export default [
  requestProvisionalDetailsSaga,
  requestCreateMissionSaga,
  requestUpdateClaimNumberSaga,
  requestValidateProvisionalLiaisonSaga,
  requestRejectProvisionalLiaisonSaga,
];
